import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { visitNotesApi, type VisitNote } from "../lib/apiClient";
import { formatVisitDate } from "../lib/formatDate";

export function VisitNotesList() {
  const [notes, setNotes] = useState<VisitNote[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    visitNotesApi
      .list()
      .then((res) => setNotes(res.items))
      .catch((err) => setError(err instanceof Error ? err.message : "Failed to load"))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p>Loading…</p>;
  if (error) return <p role="alert">{error}</p>;

  return (
    <div>
      <header className="visit-notes-header">
        <h1>Doctor visit notes</h1>
        <Link to="/visit-notes/new">New note</Link>
      </header>
      {notes.length === 0 ? (
        <p>No visit notes yet.</p>
      ) : (
        <ul>
          {notes.map((note) => (
            <li key={note.id}>
              <Link to={`/visit-notes/${note.id}`}>
                {note.patientName} — {formatVisitDate(note.visitDate)} ({note.doctorName})
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
